export default {
    state: {
        selectedResponsible: null,
        decisionType: null,
        chancepointForm: null,
        chancepointGrade: null,
        scoreDetail: null,
    },
    actions: {},
    mutations: {
        Change_Responsible_Selected: function (state, val) {
            state.selectedResponsible = val;
        },
        DECISION_TYPE: function (state, val) {
            state.decisionType = val;
        },
        CHANCEPOINT_FORM: function (state, val) {
            state.chancepointForm = val;
        },
        CHANCEPOINT_GRADE: function (state, val) {
            state.chancepointGrade = val;
        },
        SCORE_DETAIL: function (state, val) {
            state.scoreDetail = val;
        },
    },
    getters: {}
};
